export default __webpack_public_path__ + "static/media/CrossCircleOutlined.7887cfb1.svg";